import { DeepPartial } from 'ts-essentials';
import { IThemeProps, IThemeData } from '@tencent/slide-sdk-model';
import { IClrScheme, IThemeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import { ICTColorDmlADelta, STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { BorderConverter } from '../module-property/border/border-converter';

export class ThemePropertyConverter {
    /**
     * 数据3.0转换接口
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepPartial<IThemeProps>,
        uiData: IThemeModel,
    ): void {
        if (sdkData.id !== undefined) {
            uiData.id = sdkData.id;
        }

        if (sdkData.name !== undefined) {
            uiData.name = sdkData.name;
        }

        if (sdkData.themeElements) {
            const { clrScheme, fmtScheme } = sdkData.themeElements;
            if (!uiData.clrScheme) {
                uiData.clrScheme = {};
            }
            if (!uiData.fmtScheme) {
                uiData.fmtScheme = {};
            }

            uiData.clrScheme[STSchemeColorVal.dk1] = ThemePropertyConverter.getColorString(clrScheme?.dk1);
            uiData.clrScheme[STSchemeColorVal.dk2] = ThemePropertyConverter.getColorString(clrScheme?.dk2);
            uiData.clrScheme[STSchemeColorVal.lt1] = ThemePropertyConverter.getColorString(clrScheme?.lt1);
            uiData.clrScheme[STSchemeColorVal.lt2] = ThemePropertyConverter.getColorString(clrScheme?.lt2);
            uiData.clrScheme[STSchemeColorVal.accent1] = ThemePropertyConverter.getColorString(clrScheme?.accent1);
            uiData.clrScheme[STSchemeColorVal.accent2] = ThemePropertyConverter.getColorString(clrScheme?.accent2);
            uiData.clrScheme[STSchemeColorVal.accent3] = ThemePropertyConverter.getColorString(clrScheme?.accent3);
            uiData.clrScheme[STSchemeColorVal.accent4] = ThemePropertyConverter.getColorString(clrScheme?.accent4);
            uiData.clrScheme[STSchemeColorVal.accent5] = ThemePropertyConverter.getColorString(clrScheme?.accent5);
            uiData.clrScheme[STSchemeColorVal.accent6] = ThemePropertyConverter.getColorString(clrScheme?.accent6);
            uiData.clrScheme[STSchemeColorVal.hlink] = ThemePropertyConverter.getColorString(clrScheme?.hlink);
            uiData.clrScheme[STSchemeColorVal.folHlink] = ThemePropertyConverter.getColorString(clrScheme?.folHlink);

            if (Array.isArray(fmtScheme?.lnStyleLst?.ln)) {
                if (!uiData.fmtScheme.lnStyleLst) {
                    uiData.fmtScheme.lnStyleLst = {};
                }
                uiData.fmtScheme.lnStyleLst.ln = fmtScheme?.lnStyleLst?.ln.map((ln) => {
                    const border = {};
                    BorderConverter.convertPartialDataFromSdkToUi(ln, border);
                    return border;
                });
            }
        }
    }

    public static getColorString(colorDmlADelta) {
        return colorDmlADelta?.srgbClr?.val || colorDmlADelta?.sysClr?.lastClr;
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IThemeModel>,
        sdkData: IThemeData,
    ): void {

    }
}
